import { render, staticRenderFns } from "./menuField_list.vue?vue&type=template&id=dc20b45c&scoped=true&"
import script from "./menuField_list.vue?vue&type=script&lang=js&"
export * from "./menuField_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc20b45c",
  null
  
)

export default component.exports